import { getDokbox, getDokboxFiles, showDokboxFile } from "../../api/dokbox";

const getDefaultState = () => {
    return {
        details: {},
        files: [],
        reset: false,
        base64Images: {},
    };
};

const state = getDefaultState();

const getters = {
    categories: (state) => {
        let categories = {};
        if ("categories" in state.details) {
            for (let detail of state.details.categories) {
                categories[detail.id] = detail;
            }
        }
        categories["99"] = {
            id: 99,
            isusercategory: false,
            name: "Postbox",
        };

        return categories;
    },
    timeline: (state, getters, rootState) => {
        let result = [];
        if ("timeline" in state.details) {
            for (let value of state.details.timeline) {
                result.push(value);
            }
        }
        for (let key in rootState.postbox.all) {
            const postboxFile = rootState.postbox.all[key];
            const year = postboxFile.CreationDate.substring(0, 4);
            if (!result.includes(year)) {
                result.push(year);
            }
        }
        result.sort(function (a, b) {
            return b - a;
        });
        return result;
    },
    images: (state) => {
        let images = [];
        for (let file of state.files) {
            if (file.fileType !== "pdf") {
                images.push(file);
            }
        }
        return images;
    },
    fileGroups: (state, getters, rootState) => {
        let fileGroups = [];
        const files = state.files;
        for (let file of files) {
            addFileToGroup(fileGroups, file);
        }
        for (let key in rootState.postbox.all) {
            const postboxFile = rootState.postbox.all[key];
            const dokboxFile = {
                fileCategoryId: 99,
                fileDate: postboxFile.CreationDate.substring(0, 10),
                fileDesciption: "",
                fileDownloadUrl:
                    "/servlets/klickmal/api/?Mode=MeinServicebereich&Function=GetPostBoxFile&fileid=" +
                    key,
                fileHash: "M7MCMSM7OC15E2M86P093K4FJ1",
                fileId: -1,
                fileIs360: false,
                fileName: postboxFile.Title,
                filePublic: false,
                fileThumbnailUrl: "",
                fileType: "pdf",
                fileUrl: "",
            };
            addFileToGroup(fileGroups, dokboxFile);
        }
        const sortedFileGroups = fileGroups.sort(
            (a, b) => new Date(b.date) - new Date(a.date)
        );
        return sortedFileGroups;
    },
};

const addFileToGroup = function (fileGroups, file) {
    let fileGroupFound = false;
    for (let fileGroup of fileGroups) {
        if (
            fileGroup.categoryId === file.fileCategoryId &&
            fileGroup.date === file.fileDate &&
            fileGroup.description === file.fileDesciption &&
            fileGroup.name === file.fileName &&
            fileGroup.ispublic === file.filePublic
        ) {
            fileGroup.files.push(file);
            fileGroupFound = true;
            break;
        }
    }
    if (!fileGroupFound) {
        let fileGroup = {};
        fileGroup.categoryId = file.fileCategoryId;
        fileGroup.date = file.fileDate;
        fileGroup.description = file.fileDesciption;
        fileGroup.name = file.fileName;
        fileGroup.ispublic = file.filePublic;
        fileGroup.files = [];
        fileGroup.files.push(file);
        fileGroups.push(fileGroup);
    }
};

const actions = {
    getDokbox({ commit, state }) {
        return new Promise((resolve) => {
            if (Object.keys(state.details).length === 0) {
                commit("setLoading", true, { root: true });
            }
            getDokbox().then((response) => {
                if (response.data.Status === 200) {
                    commit("setDetails", response.data.Result);
                    resolve();
                }
            });
        });
    },
    getDokboxFiles({ commit, state, dispatch }, filterData) {
        return new Promise((resolve) => {
            if (state.files.length === 0) {
                commit("setLoading", true, { root: true });
            }
            getDokboxFiles(filterData).then((response) => {
                if (
                    response.data.Status === 200 &&
                    "files" in response.data.Result
                ) {
                    commit("setFiles", {
                        files: response.data.Result.files,
                        filterData: filterData,
                    });
                    resolve(response);
                    for (let file of response.data.Result.files) {
                        if (file.fileType !== "pdf") {
                            dispatch("showDokboxFile", {
                                fileId: file.fileHash,
                                thumb: false,
                                fileType: file.fileType,
                            });
                        }
                    }
                }
            });
        });
    },
    showDokboxFile({ commit }, params) {
        showDokboxFile(params).then((response) => {
            if (response.status === 200) {
                const base64Image =
                    "data:image/jpeg;base64," +
                    Buffer.from(response.data, "binary").toString("base64");
                commit("setBase64Image", {
                    fileId: params.fileId,
                    base64Image,
                });
            }
        });
    },
};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setDetails(state, details) {
        state.details = details;
    },
    setFiles(state, payload) {
        if (
            payload.filterData === undefined ||
            payload.filterData.limitStart === 0
        ) {
            state.files = payload.files;
        } else {
            state.files = state.files.concat(payload.files);
        }
    },
    setFile(state, newFile) {
        const fileIndex = state.files.findIndex((file) => {
            return file.fileId === newFile.fileId;
        });
        state.files.splice(fileIndex, 1, {
            ...state.files[fileIndex],
            ...newFile,
        });
    },
    setReset(state, value) {
        state.reset = value;
    },
    setBase64Image(state, payload) {
        state.base64Images = Object.assign({}, state.base64Images, {
            [payload.fileId]: payload.base64Image,
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
